<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="width: 200px"></el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.card_number" placeholder="Card number" clearable
          style="width: 160px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading"
      element-loading-text="Loading..." style="width:1072px;">
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="business_name" label="Business Name" width="150"></el-table-column>
      <el-table-column prop="card_number" label="Card Number" width="150"></el-table-column>
      <el-table-column prop="amount" label="Locked Amount" width="120"></el-table-column>
      <el-table-column prop="country" label="Country" width="100"></el-table-column>
      <el-table-column prop="system_name" label="System Name" width="150"></el-table-column>
      <el-table-column prop="save_time" label="Save Time" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.save_time | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit / Add 弹窗 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="150px" :model="editForm" ref="editForm" :rules="rules">

        <!-- 第一步：选国家/商户 -->
        <el-form-item label="Country/Business" prop="business_name">
          <el-cascader :options="country_business" size="small"
            :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
            placeholder="Country/Business" v-model="editForm.cascaderValue" @change="editCascaderChange"
            style="width: 100%"></el-cascader>
        </el-form-item>

        <!-- 第二步：选卡号（选了商户后才显示，动态加载该商户下的卡） -->
        <el-form-item label="Card Number" prop="card_number">
          <el-select
            v-model="editForm.card_number"
            size="small"
            placeholder="Please select business first"
            :loading="cardLoading"
            :disabled="!editForm.business_name || cardLoading"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="card in cardOptions"
              :key="card.id"
              :label="card.number + (card.name ? '  (' + card.name + ')' : '')"
              :value="card.number"
            ></el-option>
          </el-select>
          <div v-if="editForm.business_name && !cardLoading && cardOptions.length === 0"
            style="font-size:12px; color:#F56C6C; margin-top:4px">
            No cards found for this business
          </div>
        </el-form-item>

        <el-form-item label="Locked Amount" prop="amount">
          <el-input size="small" v-model="editForm.amount" placeholder="Locked Amount" clearable></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  lockCardList,
  lockCardSave,
  lockCardDelete,
  getCountryBusiness,
  getCardByBusiness,   // 新增：根据商户获取卡列表
} from '../../api/apiFun'
import {
  timestampToTime,
  cascaderChange,
} from '@/utils/util'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false,
      cardLoading: false,   // 卡列表加载状态
      editFormVisible: false,
      title: 'Add',
      editForm: {
        id: '',
        cascaderValue: [],
        country: '',
        business_name: '',
        business_id: '',
        card_number: '',
        amount: '',
      },
      cardOptions: [],      // 当前商户下的卡列表
      rules: {
        business_name: [{
          required: true,
          message: 'Please select country/business',
          trigger: 'change'
        }],
        card_number: [{
          required: true,
          message: 'Please select a card',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: 'Please enter the amount',
          trigger: 'blur'
        }],
      },
      params: {
        page: 1,
        limit: 10,
        country: '',
        business_name: '',
        card_number: '',
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      country_business: [],
    }
  },
  components: {
    Pagination
  },
  filters: {
    timestampToTime(timestamp) {
      return timestampToTime(timestamp)
    }
  },
  created() {
    this.getdata(this.params)
    this.getCountryBusiness()
  },
  methods: {
    // 拉取国家/商户树形数据
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.country_business = res.datas
        }
      }).catch(() => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    // 根据商户名称拉取卡列表
    getCardByBusiness(business_name) {
      if (!business_name) {
        this.cardOptions = []
        return
      }
      this.cardLoading = true
      this.editForm.card_number = ''  // 切换商户时清空已选卡
      getCardByBusiness({ business_name }).then(res => {
        this.cardLoading = false
        if (res.code == 200) {
          this.cardOptions = res.datas.list || []
          this.editForm.business_id = res.datas.business_id || ''
        } else {
          this.cardOptions = []
          this.$message({ type: 'info', message: res.msg })
        }
      }).catch(() => {
        this.cardLoading = false
        this.cardOptions = []
        this.$message.error('Failed to get card list, please try again later!')
      })
    },
    // 搜索栏级联选择器回调
    cascaderChange(value) {
      var result = cascaderChange(value)
      this.params.country       = result[0] || ''
      this.params.business_name = result[1] || ''
    },
    // 弹窗内级联选择器回调：选中商户后自动拉取卡列表
    editCascaderChange(value) {
      if (!value || value.length === 0) {
        this.editForm.country       = ''
        this.editForm.business_name = ''
        this.editForm.business_id   = ''
        this.cardOptions            = []
        this.editForm.card_number   = ''
      } else if (value.length === 1) {
        // 只选了一级（商户，无国家）
        this.editForm.country       = ''
        this.editForm.business_name = value[0]
        this.getCardByBusiness(value[0])
      } else {
        // 选了国家 + 商户两级
        this.editForm.country       = value[0]
        this.editForm.business_name = value[1]
        this.getCardByBusiness(value[1])
      }
    },
    // 获取列表
    getdata(parameter) {
      this.loading = true
      lockCardList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.listData = res.datas.list
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('Failed to get list, please try again later!')
      })
    },
    // 分页
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
    // 显示 Edit/Add 弹窗
    handleEdit(index, row) {
      this.editFormVisible = true
      this.cardOptions = []
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.id            = row.id
        this.editForm.country       = row.country || ''
        this.editForm.business_name = row.business_name
        this.editForm.business_id   = row.business_id
        this.editForm.card_number   = row.card_number
        this.editForm.amount        = row.amount
        this.editForm.cascaderValue = row.country
          ? [row.country, row.business_name]
          : [row.business_name]
        // 编辑时回显卡列表（先加载，再回显选中值）
        this.getCardByBusiness(row.business_name).then && null
        getCardByBusiness({ business_name: row.business_name }).then(res => {
          if (res.code == 200) {
            this.cardOptions = res.datas.list || []
            this.editForm.business_id = res.datas.business_id || ''
          }
        }).catch(() => {})
      } else {
        this.title = 'Add'
        this.editForm.id            = ''
        this.editForm.cascaderValue = []
        this.editForm.country       = ''
        this.editForm.business_name = ''
        this.editForm.business_id   = ''
        this.editForm.card_number   = ''
        this.editForm.amount        = ''
      }
    },
    // 保存
    submitForm(editData) {
      this.loading = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          const cascaderValue = this.editForm.cascaderValue.join(',')
          if (!cascaderValue) {
            this.$message.error('Please select country/business')
            this.loading = false
            return
          }
          lockCardSave({ ...this.editForm, cascaderValue }).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({ type: 'success', message: 'Saved successfully!' })
            } else {
              this.$message({ type: 'info', message: res.msg })
            }
          }).catch(() => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('Save failed, please try again later!')
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm('Are you sure to delete this record?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        lockCardDelete({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.listData.splice(index, 1)
            this.$message({ type: 'success', message: 'Deleted successfully!' })
          } else {
            this.$message({ type: 'info', message: res.msg })
          }
        }).catch(() => {
          this.$message.error('Delete failed, please try again later!')
        })
      }).catch(() => { })
    },
    // 关闭弹窗
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/business_settlement/lock_card_list.vue